import { Presentation } from '../../../core/gameflow/controller/Presentation';
import { GameSetting } from '../../../core/setting/GameSetting';
import { Beheaded } from '../../Beheaded';
import { GameData } from '../../server/data/GameData';

export class IdlePresentation extends Presentation {

    private willBounce:boolean = false;
    private bounceDurr:number = 2;
    public setGamedData(data: GameData): void {
        this.willBounce = data.currentLevel > 0 && data.currentLevel != 5;

        if(GameSetting.isBoostedBet && data.currentLevel == 1)
            this.willBounce = false;
    }

    public createPresentation(): void {
        
        if(this.willBounce){
            Beheaded.overlayAnim.endFade(this.bounceDurr);
            this.timeline.to(this,{duration:this.bounceDurr/4});
        }

        this.PresentationState.setInactive();
    }
}
